import { $t } from '@/i18n';
import { defineComponent, onMounted, onUnmounted, ref, computed } from '@vue/composition-api';
import { jsonToYaml } from '@/utils/merge/jsonToYaml';
import { useRouter } from '@/router/useRouter';
import { aiMergeEditorRoutePath } from '@/router/route-const';
import { BASE_PATH } from '@/config/constant';
import { BuildingBlocksAnimation } from '@/pages/project/project-generator/loading';
/**
 * AI 冲突编辑器视图组件
 * 通过 iframe 嵌入 AI 合并编辑器，处理 AI 项目的冲突解决
 */
export default defineComponent({
    name: 'AIConflictEditorView',
    props: {
        conflictItem: {
            type: Object,
            default: () => ({}),
        },
        currentBranchLabel: {
            type: String,
            default: '',
        },
        mergeBranchLabel: {
            type: String,
            default: '',
        },
    },
    emits: ['change'],
    setup(props, { emit }) {
        const { route } = useRouter();
        const iframeRef = ref(null);
        const showLoading = ref(true); // 控制全屏蒙层显示状态
        // 获取当前分支的主分支数据
        const oursMainBranch = computed(() => props.conflictItem?.oursData?.mainBranch || '');
        const theirsMainBranch = computed(() => props.conflictItem?.theirsData?.mainBranch || '');
        // 构建 iframe URL
        const iframeSrc = computed(() => {
            const projectId = route.value?.query?.projectid || '';
            const branch = route.value?.query?.branch || '';
            const params = new URLSearchParams({
                projectid: projectId,
                branch,
                ours: oursMainBranch.value,
                theirs: theirsMainBranch.value,
                oursName: props.currentBranchLabel,
                theirsName: props.mergeBranchLabel,
            });
            // 构建完整的 URL 路径
            const basePath = BASE_PATH || '';
            return `${basePath.replace(/\/$/, '')}${aiMergeEditorRoutePath}?${params.toString()}`;
        });
        // 处理来自 iframe 的消息
        const handleMessage = (event) => {
            const { data } = event;
            if (data?.source !== 'ai-editor-merge')
                return;
            switch (data.type) {
                case 'ready':
                    console.log('[AIConflictEditorView] Editor iframe ready:', data.payload);
                    break;
                case 'mergeSuccess':
                    console.log('[AIConflictEditorView] Merge success:', data.payload);
                    if (data.payload?.projectInfo) {
                        const change = jsonToYaml(data.payload.projectInfo);
                        emit('change', { data: change, resolved: true });
                    }
                    break;
                case 'error':
                    console.error('[AIConflictEditorView] Editor error:', data.payload?.message);
                    break;
                default:
                    console.log('[AIConflictEditorView] Unknown message type:', data.type);
            }
            showLoading.value = false;
        };
        onMounted(() => {
            window.addEventListener('message', handleMessage);
        });
        onUnmounted(() => {
            window.removeEventListener('message', handleMessage);
        });
        return {
            iframeRef,
            iframeSrc,
            showLoading,
        };
    },
    render() {
        return (<div class="w-full h-[calc(100vh-230px)] relative">
        <iframe ref="iframeRef" src={this.iframeSrc} class="w-full h-full border-0" sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-clipboard-read allow-clipboard-write"/>
        {/* 全屏蒙层 - 在 iframe 加载完成前阻止用户操作 */}
        {this.showLoading && (<BuildingBlocksAnimation fullscreen text={$t('k_2744c3ae')}/>)}
      </div>);
    },
});
